import { render } from "./CashLimitManagement.vue?vue&type=template&id=6acb6b6b&scoped=true"
import script from "./CashLimitManagement.vue?vue&type=script&lang=js"
export * from "./CashLimitManagement.vue?vue&type=script&lang=js"

import "./CashLimitManagement.vue?vue&type=style&index=0&id=6acb6b6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acb6b6b"]])

export default __exports__